import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { SenaryParagraphHeading } from 'components/Headings';
import IconButton from 'components/IconButton';
import { TYPES } from 'constants/topNavigation';
import Theme from 'styles/theme';

const ARIA_CONTROLS = 'top-navigation-drawer-desktop';

const TopNavigationHeaderDesktopButton = ({
  l1Option,
  closeTopNavigation,
  setCurrentTopNavigationNode,
  isTopNavigationOpen,
  trackNavigationClick,
}) => {
  const handleClick = () => {
    if (l1Option.isActive) {
      closeTopNavigation();
    } else {
      setCurrentTopNavigationNode(l1Option.id);
    }
    trackNavigationClick({
      navigationType: TYPES.GLOBAL,
      navigationLevel1: l1Option.label,
      navigationSource: window.location.href,
    });
  };
  return (
    <div className="TopNavigationHeaderDesktop__button-wrapper">
      <IconButton
        onClick={() => handleClick()}
        className="TopNavigationHeaderDesktop__button"
        aria-controls={ARIA_CONTROLS}
        aria-expanded={isTopNavigationOpen}
        aria-label={l1Option.label}
      >
        <div
          className={classNames('TopNavigationHeaderDesktop__button-content', {
            'TopNavigationHeaderDesktop__button-content--active': l1Option.isActive,
            'TopNavigationHeaderDesktop__button--red-color': l1Option.isSalesColorRed,
          })}
        >
          <SenaryParagraphHeading className="TopNavigationHeaderDesktop__button-label">
            {l1Option.label}
          </SenaryParagraphHeading>
        </div>
      </IconButton>
      <style jsx>{`
        .TopNavigationHeaderDesktop__button-wrapper {
          position: relative;
          align-items: center;
        }

        .TopNavigationHeaderDesktop__button-content {
          display: flex;
          justify-content: center;
          margin: 0 ${Theme.get('spacing') * 1.5}px;
        }

        .TopNavigationHeaderDesktop__button-content:hover,
        .TopNavigationHeaderDesktop__button-content--active {
          text-decoration: underline;
        }
      `}</style>
      <style jsx global>
        {`
          .TopNavigationHeaderDesktop__button {
            -moz-appearance: none;
            min-height: 0px;
          }

          .TopNavigationHeaderDesktop__button--red-color .TopNavigationHeaderDesktop__button-label {
            color: ${Theme.get('colors-discount-red')};
          }
        `}
      </style>
    </div>
  );
};

TopNavigationHeaderDesktopButton.propTypes = {
  l1Option: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    isSalesColorRed: PropTypes.bool,
  }).isRequired,
  closeTopNavigation: PropTypes.func.isRequired,
  setCurrentTopNavigationNode: PropTypes.func.isRequired,
  isTopNavigationOpen: PropTypes.bool.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
};

export default TopNavigationHeaderDesktopButton;
